export const PENDING_COURSES = [
  'hr',
  'market',
  'customer',
  'it',
  'E-commerce',
  'ngo',
  'startup',
  'ransomware',
  'socialMedia',
  'PPII',
  'dataLeakage',
  'whatsapp',
];
